import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Balance } from "./Balance";
import cls from "./Header.module.css";
import { HeaderDropdown } from "./HeaderDropdown";

import { NotificationDropdown } from "@/features/notification/toggleNotificationDropdown/ui/NotificationDropdown";
import { PersonalManagerDropdown } from "@/features/personalManager/togglePersonalManagerDropdown";
import { TUTORIAL_ANCHORS, tutorialAnchor, TutorialButton } from "@/features/tutorial";
import LogoIcon from "@/shared/assets/icons/logoIcon.svg";
import QuestionIcon from "@/shared/assets/icons/questionIcon.svg";
import WalletIcon from "@/shared/assets/icons/walletIcon.svg";
import { ROUTES } from "@/shared/config";

export const Header = () => {
    const { i18n } = useTranslation();

    i18n.on("languageChanged", (lng) => {
        dayjs.locale(lng);
    });

    return (
        <header className={cls.header} data-qa="header">
            <div className={cls["search-wrapper"]}>
                <Link to={ROUTES.CAMPAIGNS} aria-label="AppGrade — home" data-qa="header-logo-link">
                    <LogoIcon />
                </Link>
                {/* <SearchCampaigns /> */}
            </div>

            <div className={cls["account-wrapper"]}>
                {/* TODO: раскомментировать, когда захотим потестить */}
                {/* <Select
                    aria-label={t("regular.filters.options.platform", { defaultValue: "Language" })}
                    classNames={{ wrapperClassName: cls.lang }}
                    items={[
                        { key: "en", label: "EN" },
                        { key: "ru", label: "RU" },
                    ]}
                    initValue={i18n.language}
                    onChange={(e) => {
                        if (!e) return null;

                        return i18n.changeLanguage(e.key);
                    }}
                /> */}
                <TutorialButton data-qa="header-tour-button" />
                <div className={cls["help-group"]} {...tutorialAnchor(TUTORIAL_ANCHORS.HELP)}>
                    <a
                        className={cls.documentation}
                        href="https://docs.appgrade.pro/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Documentation"
                        data-qa="header-docs-link"
                    >
                        <QuestionIcon />
                    </a>
                    <div className={cls.divider} />
                    <NotificationDropdown />
                    <div className={cls.divider} />
                    <PersonalManagerDropdown />
                </div>
                <div className={cls.divider} />
                <Link
                    to={ROUTES.FINANCES}
                    className={cls.wallet}
                    data-qa="header-balance-link"
                    {...tutorialAnchor(TUTORIAL_ANCHORS.BALANCE)}
                >
                    <WalletIcon className={cls.icon} />
                    <Balance />
                </Link>
                <div className={cls["dropdown-anchor"]}>
                    <div className={cls.divider} />
                    <HeaderDropdown />
                </div>
            </div>
        </header>
    );
};
